export default "__VITE_ASSET__CtlxZ3Vx__"